import { Slider, Slide } from 'components/Slider/Slider';
import { Button } from 'components/buttons/Button/Button';
import HeroNewsCard from 'pages/Homepage/Hero/HeroNewsCard';
import { stayUpToDate } from 'assets/mockData/stayUpToDate';
import hero from 'videos/hero.mp4';
import 'swiper/css';
import './styles.scss';
import GradientText from 'components/GradientText';

const Hero = () => {
    const onFullPageSolutions = () => {
        window.location.href = '#information-wrapper';
    };

    return (
        <div className="container">
            <div className="hero">
                <video autoPlay loop muted>
                    <source src={hero} type="video/mp4" />
                </video>
                <GradientText textColor="white">
                    <h1>
                        Ahead <br /> of <em>climate</em> change.
                    </h1>
                </GradientText>
            </div>
            <div className="information-wrapper">
                <div className="information-wrapper__offer-section">
                    <p className="description-medium">
                        We offer solutions that can
                        <br /> respond <span className="color-text">to future climate change</span>
                        <br /> and related challenges.
                    </p>
                    <Button type="white-arrow" onClick={onFullPageSolutions} />
                </div>
                <div className="information-wrapper__box-for-border"></div>
                <div className="information-wrapper__box-for-border radius16"></div>
                <div className="information-wrapper__box-for-border location-left"></div>
                <div className="information-wrapper__box-for-border location-left radius16"></div>
                <div className="information-wrapper__news-wrapper">
                    <Slider className="slider-head">
                        {stayUpToDate?.map(el => (
                            <Slide key={el.article}>
                                <HeroNewsCard card={el} array={stayUpToDate} />
                            </Slide>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default Hero;
